import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Moon, Lock, Download } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
const CHECKOUT_URL = 'https://vidassinlimites.com/cart/47016729903282:1';
export function Hero() {
  const handleCheckout = () => {
    // Track InitiateCheckout event before redirecting
    trackInitiateCheckout();
    // Small delay to ensure tracking fires before redirect
    setTimeout(() => {
      window.location.href = CHECKOUT_URL;
    }, 300);
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-[#0a0a0f] pt-12 pb-8 px-4" data-id="element-71">
      {/* Background ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[400px] bg-[#ff2d7a]/8 blur-[100px] rounded-full pointer-events-none" data-id="element-72" />

      <div className="max-w-6xl mx-auto w-full grid lg:grid-cols-2 gap-8 lg:gap-12 items-center relative z-10" data-id="element-73">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-74">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#ff2d7a]/10 border border-[#ff2d7a]/20 text-[#ff2d7a] text-xs font-semibold mb-4" data-id="element-75">
            <Moon size={12} data-id="element-76" />
            <span data-id="element-77">Edición Nocturna</span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-[#f5f5f5] leading-tight mb-4" data-id="element-78">
            7 noches para volver a sentirse{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff2d7a] to-[#ff80ab]" data-id="element-79">
              elegidos
            </span>
          </h1>

          <p className="text-lg text-gray-300 mb-6 font-light" data-id="element-80">
            Sin babysitter. Sin planes caros.
            <br data-id="element-81" />
            Sin conversaciones eternas.
          </p>

          <div className="flex flex-col gap-3 items-center lg:items-start" data-id="element-82">
            <Button size="lg" className="group w-full sm:w-auto" onClick={handleCheckout} data-id="element-83">
              Quiero el Protocolo
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-84" />
            </Button>

            <div className="flex items-center gap-4 text-xs text-gray-500" data-id="element-85">
              <span className="flex items-center gap-1" data-id="element-86">
                <Download size={12} className="text-[#ff2d7a]" data-id="element-87" />
                Descarga digital inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-88">
                <Lock size={12} className="text-[#ff2d7a]" data-id="element-89" />
                100% Privado
              </span>
            </div>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="relative order-1 lg:order-2" data-id="element-90">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#ff2d7a]/15 border border-white/5" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/2BXhjipd2LCpTEScJNbStm/mockup_oficial.png" alt="El Protocolo 7D de Conexión Real" className="w-full h-auto object-cover" data-id="element-92" />
          </div>
        </motion.div>
      </div>
    </section>;
}